import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { LottieComponent, type AnimationOptions } from 'ngx-lottie';

import { UiBrandingService } from '@core/services/ui-branding.service';

import { Dynamic } from '@shared/registry';

import type { OverlaySplashBranding, OverlaySplashConfig, OverlaySplashVariant } from './overlay-splash.types';

@Component({
  selector: 'app-overlay-splash',
  templateUrl: './overlay-splash.html',
  imports: [NgStyle, LottieComponent, Dynamic],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'h-full' },
})
export class OverlaySplash {
  private readonly brandingService = inject(UiBrandingService);

  readonly config = input<OverlaySplashConfig>({});
  readonly variant = input<OverlaySplashVariant>('default');

  private readonly brandingKey = computed(() => (this.variant() === 'entry' ? 'entrysplash' : 'overlaysplash'));

  private readonly brandingConfig = computed(() => {
    const branding = this.brandingService.branding();
    const components = branding?.['components'] as Record<string, unknown> | undefined;
    return components?.[this.brandingKey()] as OverlaySplashBranding | undefined;
  });

  protected readonly isEntryVariant = computed(() => this.variant() === 'entry');
  protected readonly lottieUrl = computed(() => this.brandingConfig()?.lottieUrl);

  protected readonly containerStyle = computed(() => {
    if (!this.isEntryVariant()) return null;
    const url = this.brandingConfig()?.backgroundUrl;
    if (!url) return { backgroundColor: 'var(--page-background)' };
    return { backgroundImage: `url(${url})`, backgroundSize: 'cover', backgroundPosition: 'center' };
  });

  protected readonly lottieOptions = computed<AnimationOptions>(() => ({
    path: this.lottieUrl(),
    loop: true,
    autoplay: true,
  }));
}
